import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { DynamicTicketTypeNotifyAssigneeMode } from '@app/services/dynamic-ticket-type.service';
import { DaysToStringPipe } from '@main-application/inspections/pipes/days-to-string.pipe';

import {
  CustomNotifyId,
  DontNotifyId,
  OnDueDateNotifyId,
} from '../inspection-add-regular-form/inspection-add-regular-form.component';

@Component({
  selector: 'app-notify-message',
  templateUrl: './notify-message.component.html',
  styleUrls: ['./notify-message.component.scss'],
  standalone: true,
  imports: [CommonModule, DaysToStringPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotifyMessageComponent {
  @Input() assigneeName: string | null = null;
  @Input() declare inspectionType?: string;
  @Input() showCreateMessage = false;
  @Input() declare notifyAssignee: boolean;
  @Input() createOrNotifyOn: number;
  @Input() customNotifyOnMode: DynamicTicketTypeNotifyAssigneeMode = DynamicTicketTypeNotifyAssigneeMode.OnDueDate;
  @Input() declare customNotifyOn: number;
  @Input() remindOn: number;
  @Input() declare thenRemindOn: number;
  @Input() until: number;

  @Output() onOpenDialog = new EventEmitter();

  CustomNotifyId = CustomNotifyId;
  OnDueDateNotifyId = OnDueDateNotifyId;
  DontNotifyId = DontNotifyId;
  DynamicTicketTypeNotifyAssigneeMode = DynamicTicketTypeNotifyAssigneeMode;

  openDialog() {
    this.onOpenDialog.emit();
  }
}
